import { Link } from "react-router";
import { categories } from "../data/shows.js";
import AdBanner from "../components/AdsBanner.jsx";

const base = "flex items-center justify-between gap-3 rounded-2xl border px-5 py-5 font-display text-xl font-bold sm:text-2xl";

export default function Home() {
  return (
    <section>
      <h1 className="mb-6 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Watch Free</h1>

      <ul className="grid gap-3 grid-cols-2 sm:grid-cols-3">
        {/* ads line native ban ads */}
        <script async="async" data-cfasync="false" src="https://bellnewyork.org/21/e0480befad762d7e5f14a45960f9e186"></script>
        <div id="container-e0480befad762d7e5f14a45960f9e186"></div>
        
        {categories.map((c) => (
          <li key={c.slug}>
            {c.comingSoon ? (
              <div aria-disabled="true" className={`${base} cursor-not-allowed border-line/60 bg-panel/40 text-mist`}>
                {c.title}
                <span className="shrink-0 -mt-15.5 -ml-29 rounded-full border border-glow/50 px-3 py-1 font-sans text-xs font-semibold text-glow">
                  Coming soon
                </span>
              </div>
            ) : (
              <Link
                to={`/show/${c.slug}`}
                className={`${base} border-line bg-panel transition hover:-translate-y-0.5 hover:border-glow focus-visible:outline-2 focus-visible:outline-glow`}
              >
                {c.title}
                <span aria-hidden className="text-glow">›</span>
              </Link>
            )}

            

            
          </li>
          
        ))}
        
      </ul>

      {/* ye banner ads call hai */}
      <AdBanner></AdBanner>

      
    </section>

    
    
    
  );
  
}
